import session from "csi/session";
import types from "csi/types";
import { C8Node, IDataStore } from "csi/typings";
import xml from "csi/xml";
import { ILocaleProvider, useLocale } from "designSystem/locale";
import React, { FunctionComponent } from "react";
import "src/css/variables.css";
import { classes, ComplianceAnalysisCard } from "./ComplianceAnalysisCard";
import NodeDataStore from "csi/datastore/NodeDataStore";


/**
 * ComplianceAnalysis Entry message Format:
 * NodeName
 * {AnalysisStatus}
 * {ParentDataSheetRevisionState}
 * {Request Sent time}
 * {AnalysisType}
 * {ComplianceSystemResultsUIURL }
*/

export interface ComplianceAnalysisCardBaseProductProps
{
	className?: string;
	id: string;
	item: C8Node;
	onClick: VoidFunction;
	onDelete?: VoidFunction;
	selected?: boolean;
	selecting?: boolean;
	store: IDataStore<C8Node>;
}

const getParentDataSheet = (item: C8Node, store: IDataStore<C8Node>) => {
	if (store instanceof NodeDataStore) {
		const foodLabelDataSheet = store.cache.get(item?.__Parent__);
		const parentDataSheetRevision = store.cache.get(foodLabelDataSheet?.ParentDataSheetRevision);
		const parentDataSheet = store.cache.get(parentDataSheetRevision?.__Parent__);
		return parentDataSheet;
	}

	return null;
};

export const ComplianceAnalysisCardBaseProduct: FunctionComponent<ComplianceAnalysisCardBaseProductProps> = (props) => {
	const { className, id, item, onClick, onDelete, selected, selecting, store } = props;
	const loc: ILocaleProvider = useLocale();

	const parentDataSheet = getParentDataSheet(item, store);
	const parentDataSheetLink = parentDataSheet ? session.getLocationForUrl(parentDataSheet.$URL) : null;
	const parentDataSheetName = parentDataSheet?.$Name;
	const nodeName = item["Node Name"];
	const dataSheet = loc.resource("DataSheet") + ": ";
	const dataSheetRev = loc.resource("ParentDataSheetRevisionName", [item.ParentDataSheetRevisionName]);
	const revState = loc.enumResource(item.ParentDataSheetRevisionState);
	const stateCssClass = "csi-name-value-pair csi-state csi-state-" + revState.toLowerCase();
	const analysisState = loc.resource("AnalysisStatus", [item.AnalysisStatus]);
	const requestSentTime = loc.resource("RequestSentTime", [types.formatTime(item.$CT, types.FORMAT_DATETIME)]);
	const analysisURL = loc.resource("ComplianceSystemResultsUIURL") + ": ";

	const panelContent: FunctionComponent = () => {
		return (
			<div className={classes.panelCard}>
				<div className={classes.nodeName}>
					{nodeName}
				</div>
				<div className={classes.text}>
					{analysisState}
				</div>
				<div className={classes.text}>
					{dataSheet} <a href={parentDataSheetLink} target="_blank">{parentDataSheetName}</a>
				</div>
				<div className={classes.text}>
					{dataSheetRev}
				</div>
				<div className={classes.text}>
					<span className={stateCssClass}>{revState}</span>
				</div>
				<div className={classes.text}>
					{requestSentTime}
				</div>
				<div className={classes.text}>
					{analysisURL} <a href={item.ComplianceSystemResultsUIURL} target="_blank">{item.ComplianceSystemResultsUIURL}</a>
				</div>
			</div>
		);
	};

	return (
		<ComplianceAnalysisCard
			PanelContent={panelContent}
			cardDesignType="default"
			className={className}
			id={id}
			item={item}
			onClick={onClick}
			onDelete={onDelete}
			selected={selected}
			selecting={selecting}
			store={store}
		/>
	);
};
